export const variants = {
    df: 'df', // Default variant
    ctf: 'ctf',
    sw: 'sw',
    ew: 'ew',
    pd: 'pd',
    of: 'of',
    br: 'br',
    sf: 'sf',
    ev: 'ev'
}


